import Cookies from 'js-cookie';
import { decryptData } from 'utils/crypto';



export const leaveSteps =()=>{
const roleId = Number(decryptData(Cookies.get('role_id')));

 return [
    {
    target: '[data-tour="leave-module"]',
    title: '🌴 Welcome to the Leave Module',
    content:
      'This module allows you to apply for leave, track your leave requests, review leave policies, and manage leave records based on your role.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="apply-leave-tab"]',
    title: '📝 Apply Leave',
    content:
      'Use this section to submit leave requests for approval.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="leave-logs-tab"]',
    title: '📋 Leave Logs',
    content:
      'View all your submitted leave requests and their current status.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="leave-rules-tab"]',
    title: '📖 Leave Rules',
    content:
      'Review company leave policies, eligibility, and guidelines.',
    disableBeacon: true,
  },
  ...(roleId === 1 || roleId === 2
    ? [
        {
          target: '[data-tour="leave-records-tab"]',
          title: '📊 Leave Records',
          content:
            'Managers and administrators can review employee leave records here.',
          disableBeacon: true,
        },
      ]
    : []),
];
}